import { styled } from '@uhg-abyss/web/tools/styled';

export const WidgetDisclaimersWrapper = styled('div', {
  display: 'inline-block',
});
